import { render, staticRenderFns } from "./AddProfessionalSkillDialog.vue?vue&type=template&id=67740406&"
import script from "./AddProfessionalSkillDialog.vue?vue&type=script&lang=js&"
export * from "./AddProfessionalSkillDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VInput } from 'vuetify/lib/components/VInput';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VBtn,VForm,VInput,VRating})
